import { isAfter, isValid } from "date-fns";

import { IPrequalificationInfoResponse } from "./prequalification.interface";

/**
 * Query-param flag marking the renewal entry into the /prequalification funnel
 * (from the renewal interceptor modal). When present, the container scopes the
 * pet picker to the renewal cohort (endsSoonWPData) instead of every eligible
 * pet. Value is "true"; e.g. `?renewal=true`.
 */
export const PREQUAL_RENEWAL_PARAM = "renewal";

/**
 * A prequalification is "valid" (and therefore lets the renewal flow skip the
 * intro/interceptor step) when all of the following hold:
 *   1. status is ELIGIBLE or INELIGIBLE (a real Scratch result exists),
 *   2. expiresAt has not passed,
 *   3. the linked purchase has not yet been fulfilled
 *      (fulfilledByTransactionId and fulfilledAt are both empty).
 *
 * @param {IPrequalificationInfoResponse | null | undefined} info The record
 *   returned by getPrequalificationInfo.
 * @return {boolean} True when the record is a live, unfulfilled result.
 */
export const hasValidPrequalification = (
  info: IPrequalificationInfoResponse | null | undefined,
): boolean => {
  if (!info) return false;
  const hasResultStatus =
    info.status === "ELIGIBLE" || info.status === "INELIGIBLE";
  const expiresAt = info.expiresAt ? new Date(info.expiresAt) : null;
  const notExpired = !!expiresAt && isValid(expiresAt) && isAfter(expiresAt, new Date());
  const notFulfilled = !info.fulfilledByTransactionId && !info.fulfilledAt;
  return hasResultStatus && notExpired && notFulfilled;
};
